<template>

  <div class="wrap">

    <div class="page-header">
        <Nav :activeId="activeId" />
    </div>

    <!-- 头 -->
    <div class="section-one">
      <img src="../../img/product-2/banner.jpg" class="self" />

      <div class="nav-bar">
        <div class="nav-bar_label">PRODUCTS AND TECHNOLOGY</div>
        <div class="nav-bar_bread">
          <a href="/home">首页</a><span>产品与技术</span>六维全面水管理体系
        </div>
        <!-- <img src="../../img/product-2/nav-top2.png" class="product p-2" /> -->
      </div>
      <div class="nav-pic">
        <img src="../../img/product-2/nav-pic.png" class="product-2" />
      </div>
      <!-- <img src="../../img/product-2/title.png" class="v-c-title product-2-title" /> -->
    </div>

    <div class="section-one section-bg-product-2">
      <!-- <img src="../../img/product-2/bg2.jpg" class="bg" /> -->
      <div class="product-2-list">
        <div 
          v-for="(item, index) in itemArr" :key="index"
          :class="['item', {'active' : index==clickIndex, 'active' : index==hoverIndex }]"
          @click="clickIndex = index"
          @mouseover="hoverIndex = index"
          @mouseout="hoverIndex = -1"
        >
          <img :src="require(`@/img/product-2/item/${item}.jpg`)" class="bg" />
          <img :src="require(`@/img/product-2/title/${item}.png`)" :class="['title','t'+item]" />
          <img :src="require(`@/img/product-2/info/${item}.png`)" class="show" />
        </div>
        <!-- <div class="item">
          <img src="../../img/product-2/item/1.jpg" class="bg" />
          <img src="../../img/product-2/title/1.png" class="title t1" />
          <img src="../../img/product-2/info/1.png" class="show" />
        </div>
        <div class="item">
          <img src="../../img/product-2/item/2.jpg" class="bg" />
          <img src="../../img/product-2/title/2.png" class="title t2" />
          <img src="../../img/product-2/info/2.png" class="show" />
        </div>
        <div class="item">
          <img src="../../img/product-2/item/3.jpg" class="bg" />
          <img src="../../img/product-2/title/3.png" class="title t3" />
          <img src="../../img/product-2/info/3.png" class="show" />
        </div>
        <div class="item">
          <img src="../../img/product-2/item/4.jpg" class="bg" />
          <img src="../../img/product-2/title/4.png" class="title t4" />
          <img src="../../img/product-2/info/4.png" class="show" />
        </div>
        <div class="item">
          <img src="../../img/product-2/item/5.jpg" class="bg" />
          <img src="../../img/product-2/title/5.png" class="title t5" />
          <img src="../../img/product-2/info/5.png" class="show" />
        </div>
        <div class="item">
          <img src="../../img/product-2/item/6.jpg" class="bg" />
          <img src="../../img/product-2/title/6.png" class="title t6" />
          <img src="../../img/product-2/info/6.png" class="show" />
        </div> -->
      </div>
    </div>
    
    <Footer />
  </div>

</template>

<script>
// import $ from 'jquery'
import Nav from '../components/Nav.vue'
import Footer from '../components/Footer.vue'
export default {
  data() {
    return {
      activeId: 1,
      // chooseId: '',
      itemArr:[1,2,3,4,5,6],
      hoverIndex: -1, //表示当前hover的是第几个li 初始为 -1 或 null 不能为0 0表示第一个li
      clickIndex: -1, //表示当前点击的是第几个li 初始为 -1 或 null 不能为0 0表示第一个li
    }
  },
  components: {
    Nav,
    Footer
  },
  mounted() {
    // $('.nav-btm-line').css({
    //   left: 220 + 'px'
    // });
  },
  methods: {
    // onChoose(e) {
    //   let id = e.target.dataset.id
    //   console.log(id)
    //   this.chooseId = id
    // }
  }
};
</script>

<style scoped lang="less">
.self {
  min-height: 679px;
  height: 679px;
}
.product-2-list {
  width: 1092px;
  margin: 0 auto;
  position: absolute;
  top: 150px;
  left: 0;
  right: 0;

  display: flex;
  justify-content: space-between;
  flex-flow: row wrap;
  .item {
    width: 346px;
    height: 387px;
    position: relative;
    cursor: pointer;
    margin-bottom: 24px;
    overflow: hidden;
    &:hover, &.active {
      .title {
        // display: none;
        top: 20% !important;
        transition: all 0.2s;
        // transform: translate(-50%, -20%) !important;
      }
      .show {
        // display: block;
        bottom: 0;
        transition: all 0.5s;
      }
    }
    .bg {
      width: 100%;
      height: 100%;
      z-index: -99;
    }
    .title {
      transition: all 0.2s;
      margin: 0 auto;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      right: unset;
      bottom: unset;
      object-fit: contain;
      &.t1 { width: 173px; height: 71px; }
      &.t2 { width: 170px; height: 100px; }
      &.t3 { width: 120px; height: 75px; }
      &.t4 { width: 85px; height: 89px; }
      &.t5 { width: 175px; height: 71px; }
      &.t6 { width: 202px; height: 97px; }
    }
    .show {
      transition: all 0.2s;
      width: 346px;
      height: 248px;
      // object-fit: fill;
      // margin: 0 auto;
      position: absolute;
      left: 0;
      bottom: -348px;
      // left: 50%;
      // top: 50%;
      // transform: translate(-50%, -50%);
      // display: none;
      &.s1 { width: 429px; height: 205px; }
      &.s2 { width: 352px; height: 204px; }
    }
  }
}
</style>